import { useRef, useState } from 'react'
import styles from './styles/login.module.css'
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import jwtDecode from 'jwt-decode'
import loginIcon from '../../src/assests/icons/loginIcon.png';

export default function Login({ setToken }) {
    const [passwordVisiblity, setPasswordVisiblity] = useState(false)

    const EmailRef = useRef()
    const PassRef = useRef()

    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const redirect = searchParams.get("redirect")


    function formValidator(input, condition, error) {
        error[0].innerText = ""
        input.style.borderColor = "transparent"

        if (!condition && error[2]) {
            error[0].innerText = error[1]
            input.style.borderColor = "red"
        }

        return condition
    }

    function EmailCheck(showErrOnCondition = true) {
        const input = EmailRef.current.children[1]
        const emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const condition = emailValidator.test(input.value)
        const error = [EmailRef.current.children[2], "Valid Email is required", showErrOnCondition ? (input.value.includes("@") || input.value.length > 7) : true]


        return formValidator(input, condition, error)
    }

    function PassCheck(showErrOnCondition = true) {
        const input = PassRef.current.children[1]
        const condition = input.value.length > 0
        const error = [PassRef.current.children[2], "Password cannot be empty", showErrOnCondition ? (input.value.length > 0) : true]

        return formValidator(input, condition, error)
    }

    function handleSubmit(e) {
        e.preventDefault()

        const tests = [EmailCheck(false), PassCheck(false)]
        const isPassed = !tests.includes(false)

        if (isPassed) {
            const email = EmailRef.current.children[1].value;
            const password = PassRef.current.children[1].value;

            const formBody = JSON.stringify({ email, password })

            fetch("https://friendly-jepsen.77-68-82-89.plesk.page/user/signin", {
                method: "POST",
                body: formBody,
                headers: {
                    "content-type": "application/json"
                }
            })
                .then(res => {
                    return res.json()
                })
                .then(({ status, token, err }) => {
                    if (status == "success") {
                        setToken(token)
                        const { role } = jwtDecode(token)
                        if (role == "Admin") {
                            localStorage.setItem("admin_access_token", token)
                            navigate("/admin")
                        }
                        else {
                            localStorage.setItem("access_token", token)
                            navigate(redirect || "/")
                        }
                    }
                    else {
                        console.log(err)
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Something went wrong! Try Again',
                        })
                    }
                })
                .catch(err => console.log(err))
        }

    }
    return (
        <div className={styles.login + " "}>
            <h1>Welcome to Collection Creator.</h1>
            <p>
            Login to get started or revisit your saved design.
            </p>
            <p>
                Don’t have an account? <a className='font-bold cursor-pointer hover:underline' onClick={() => navigate("/register")}>Create an account</a>
            </p>
            <form className={styles.form}>
                <fieldset ref={EmailRef}>
                    <legend>Email</legend>
                    <input type="email" name="Email" onChange={EmailCheck} />
                    <p></p>
                </fieldset>
                <fieldset ref={PassRef}>
                    <legend>Password</legend>
                    <input type={passwordVisiblity ? "text" : "password"} name="password" onChange={PassCheck} />
                    <p> </p>
                    {
                        passwordVisiblity ?
                            <RiEyeFill className={styles.hideshow} onClick={() => { setPasswordVisiblity(!passwordVisiblity) }} />
                            :
                            <RiEyeOffFill className={styles.hideshow} onClick={() => { setPasswordVisiblity(!passwordVisiblity) }} />
                    }
                </fieldset>
                {/* <button onClick={handleSubmit} className={styles.button}>Login</button> */}
                <div onClick={handleSubmit} className={styles.icon}><img src={loginIcon} alt='loginIcon' /></div>
            </form>
        </div>
    )
}